export const UPDATE_BING_ADS = 'UPDATE_BING_ADS';

export const updateBingAds = (payload) => ({
    type: UPDATE_BING_ADS,
    payload,
});

export default (state = {}, action) =>
    action.type === UPDATE_BING_ADS ? { ...state, ...action.payload } : state;
